// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnalyticsEventVariant, AskGetabstractQuestion } from "../schema";
import { serialize_AskGetabstractAnalyticsEventVariant_internal, deserialize_AskGetabstractAnalyticsEventVariant_internal } from "./AskGetabstractAnalyticsEventVariant";

export function serialize_AskGetabstractQuestion_internal(value: AskGetabstractQuestion): unknown {
  return ((value: {
    analyticsEventVariant: AskGetabstractAnalyticsEventVariant;
    blacklistQuestions: string[];
    previousQuestionUuid: string | null;
    question: string;
    questionUuid: string;
    relatedQuestionStep: number;
    trendingQuestion: boolean;
  }): unknown => {
    return {
      analyticsEventVariant: ((value: AskGetabstractAnalyticsEventVariant): unknown => {
        return serialize_AskGetabstractAnalyticsEventVariant_internal(value);
      })(value["analyticsEventVariant"]),
      blacklistQuestions: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["blacklistQuestions"]),
      previousQuestionUuid: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["previousQuestionUuid"]),
      question: ((value: string): unknown => {
        return value;
      })(value["question"]),
      questionUuid: ((value: string): unknown => {
        return value;
      })(value["questionUuid"]),
      relatedQuestionStep: ((value: number): unknown => {
        return value;
      })(value["relatedQuestionStep"]),
      trendingQuestion: ((value: boolean): unknown => {
        return value;
      })(value["trendingQuestion"]),
    };
  })(value);
}
export function serialize_AskGetabstractQuestion(obj: AskGetabstractQuestion): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractQuestion_internal(obj));
}
export function deserialize_AskGetabstractQuestion_internal(value: unknown): ParserResult<AskGetabstractQuestion> {
  return ((
    value: unknown,
  ): ParserResult<{
    analyticsEventVariant: AskGetabstractAnalyticsEventVariant;
    blacklistQuestions: string[];
    previousQuestionUuid: string | null;
    question: string;
    questionUuid: string;
    relatedQuestionStep: number;
    trendingQuestion: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "analyticsEventVariant")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/analyticsEventVariant]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'analyticsEventVariant'.` };
    }
    const parsed_analyticsEventVariant = ((): ParserResult<AskGetabstractAnalyticsEventVariant> => {
      return ((value: unknown): ParserResult<AskGetabstractAnalyticsEventVariant> => {
        return deserialize_AskGetabstractAnalyticsEventVariant_internal(value);
      })(value["analyticsEventVariant"]);
    })();
    if (!parsed_analyticsEventVariant.success) {
      return { success: false, reason: parsed_analyticsEventVariant.reason };
    }
    if (!hasProp(value, "blacklistQuestions")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/blacklistQuestions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'blacklistQuestions'.` };
    }
    const parsed_blacklistQuestions = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/blacklistQuestions]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/blacklistQuestions]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/AskGetabstractQuestion/blacklistQuestions]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["blacklistQuestions"]);
    })();
    if (!parsed_blacklistQuestions.success) {
      return { success: false, reason: parsed_blacklistQuestions.reason };
    }
    if (!hasProp(value, "previousQuestionUuid")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/previousQuestionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'previousQuestionUuid'.` };
    }
    const parsed_previousQuestionUuid = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/previousQuestionUuid]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["previousQuestionUuid"]);
    })();
    if (!parsed_previousQuestionUuid.success) {
      return { success: false, reason: parsed_previousQuestionUuid.reason };
    }
    if (!hasProp(value, "question")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/question]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'question'.` };
    }
    const parsed_question = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/question]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["question"]);
    })();
    if (!parsed_question.success) {
      return { success: false, reason: parsed_question.reason };
    }
    if (!hasProp(value, "questionUuid")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/questionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'questionUuid'.` };
    }
    const parsed_questionUuid = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/questionUuid]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["questionUuid"]);
    })();
    if (!parsed_questionUuid.success) {
      return { success: false, reason: parsed_questionUuid.reason };
    }
    if (!hasProp(value, "relatedQuestionStep")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/relatedQuestionStep]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'relatedQuestionStep'.` };
    }
    const parsed_relatedQuestionStep = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/relatedQuestionStep]: '${value}' expected to be of type number.` };
      })(value["relatedQuestionStep"]);
    })();
    if (!parsed_relatedQuestionStep.success) {
      return { success: false, reason: parsed_relatedQuestionStep.reason };
    }
    if (!hasProp(value, "trendingQuestion")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/trendingQuestion]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'trendingQuestion'.` };
    }
    const parsed_trendingQuestion = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractQuestion/trendingQuestion]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["trendingQuestion"]);
    })();
    if (!parsed_trendingQuestion.success) {
      return { success: false, reason: parsed_trendingQuestion.reason };
    }
    return {
      success: true,
      value: {
        analyticsEventVariant: parsed_analyticsEventVariant.value,
        blacklistQuestions: parsed_blacklistQuestions.value,
        previousQuestionUuid: parsed_previousQuestionUuid.value,
        question: parsed_question.value,
        questionUuid: parsed_questionUuid.value,
        relatedQuestionStep: parsed_relatedQuestionStep.value,
        trendingQuestion: parsed_trendingQuestion.value,
      },
    };
  })(value);
}
export function deserialize_AskGetabstractQuestion(str: string): ParserResult<AskGetabstractQuestion> {
  return deserialize_AskGetabstractQuestion_internal(parseJsonWithNumbersAsBigint(str));
}
